import React, { FunctionComponent } from 'react';
import { CalculatorsStudentLoanResult } from '../../../../@types/features/calculators';

interface CalculatorStudentLoanCtaProps {
  result: CalculatorsStudentLoanResult | Record<string, string>;
}

export const CalculatorStudentLoanSummary: FunctionComponent<CalculatorStudentLoanCtaProps> = ({
  result
}) => {
  if (!result) {
    return null;
  }
  return (
    <div className={`mb-8`}>
      Je gaf aan dat {result.withPartner ? 'jullie' : 'je'} maandelijks{' '}
      <span className={`font-bold`}>{result.studentDebtAmount}</span>{' '}
      {result.withPartner ? 'aflossen' : 'aflost'} en {result.withPartner ? 'jullie' : 'je'} bruto
      jaarinkomen is <span className={`font-bold`}>{result.yearlyIncome}</span>.{' '}
      {result.withPartner && (
        <span>
          Je koopt huis met je <span className="text-orange">partner.</span>
        </span>
      )}
    </div>
  );
};
